
import { defineComponent } from 'vue';
import AdTableRow from './AdTableRow.vue';

export default defineComponent({
  name: 'AdTable',
  emits: ['selected', 'hover', 'sortBy'],
  props: {
    data: Array,
    selected: Object,
    onlyHeader: Boolean,
  },
  data() {
    return {
      tableWidth: 0,
      sortBy: '',
      sortColumnKey: '',
      isDesc: false,
      type: null as null | number,
      columns: [] as any[],
      columnsDefinitions: [],
    };
  },
  components: {
    AdTableRow,
  },
  created() {
    this.columnsDefinitions = [
      { key: 'icon', title: '&nbsp;', isSortable: false, visibleTypes: [], width: 40 },
      { key: 'street', title: this.$t('AdTable.columns.street'), isSortable: true, visibleTypes: [], width: 0 },
      { key: 'price', title: this.$t('AdTable.columns.price'), isSortable: true, visibleTypes: [], width: 0 },
      { key: 'pricePerSquareMeter', title: this.$t('AdTable.columns.price') + ' m<sup>2</sup>', isSortable: true, visibleTypes: [], width: 0 },
      { key: 'adType', title: this.$t('AdTable.columns.adType'), isSortable: false, visibleTypes: [2, 3], width: 0 },
      { key: 'bedCount', title: this.$t('AdTable.columns.bedCount'), isSortable: true, visibleTypes: [3], width: 0 },
      { key: 'roomCount', title: this.$t('AdTable.columns.roomCount'), isSortable: true, visibleTypes: [1], width: 0 },
      { key: 'landArea', title: this.$t('AdTable.columns.landArea'), isSortable: true, visibleTypes: [1, 2], width: 0 },
      { key: 'estateArea', title: this.$t('AdTable.columns.estateArea'), isSortable: true, visibleTypes: [], width: 0 },
      { key: 'createdUtc', title: this.$t('AdTable.columns.createdUtc'), isSortable: true, visibleTypes: [], width: 0 },
    ];
    this.handleColumns();
    this.$store.subscribe((mutation) => {
      if (mutation.type === 'searchAds') {
        this.handleColumns();
      }
    });
  },
  beforeUnmount() {
    if (this.onlyHeader) return;
    if (this.sortColumnKey != 'createdUtc' && this.sortColumnKey != 'price') {
      this.resetSort();
    }
  },
  methods: {
    handleColumns() {
      if (this.$store.state.adSearchParams) {
        this.updateSortBy(this.$store.state.adSearchParams.sortBy);
      }
      this.type = this.$store.state.adSearchParams.type ? this.$store.state.adSearchParams.type.key : null;
      this.columns = this.columnsDefinitions.filter((x) => x.visibleTypes.length === 0 || (this.type && x.visibleTypes.indexOf(this.type) > -1));

      if (this.onlyHeader) {
        setTimeout(() => {
          const originalTable = document.getElementById('estate-listing-table');
          if (originalTable) {
            this.tableWidth = parseFloat(window.getComputedStyle(originalTable).width);
            const originalTableHeaders = originalTable.children[0].children[0].children;
            for (let i = 0; i < originalTableHeaders.length; i++) {
              this.columns[i].width = parseFloat(window.getComputedStyle(originalTableHeaders[i]).width);
            }
          }
        }, 0);
      }

      const sortColumnFound = this.columns.filter((x) => x.key === this.sortColumnKey).length > 0;
      if (!sortColumnFound) {
        this.resetSort();
      }
    },
    updateSortBy(sortBy: string) {
      this.sortBy = sortBy;
      const descIndex = this.sortBy.indexOf(' desc');
      this.isDesc = descIndex > -1;
      this.sortColumnKey = this.isDesc ? this.sortBy.substring(0, descIndex) : this.sortBy;
    },
    resetSort() {
      this.$store.commit('searchAdSortBy', 'createdUtc desc');
    },
    onSelected(item: any) {
      this.$emit('selected', item);
    },
    onHover(item: any) {
      this.$emit('hover', item);
    },
    filter(column: any) {
      if (!column.isSortable) return;

      let sortBy = column.key;

      if (this.sortColumnKey === column.key) {
        sortBy = this.isDesc ? column.key : column.key + ' desc';
      }
      this.$store.commit('searchAdSortBy', sortBy);

      this.$emit('sortBy', sortBy);
    },
  },
});
